export default "__VITE_ASSET__CiUeawZx__"